import React, { useState, useEffect, useMemo } from 'react';
import Experience from './Experience';
import AboutMe from './AboutMe';
import ContactInformation from './ContactInformation';
import WorkExperience from './WorkExperience';
import styles from './Profile.module.css';

interface Section {
  id: string;
  title: string;
  component: React.ReactElement;
}

const Profile: React.FC = React.memo(() => {
  const [isLoading, setIsLoading] = useState(true);

  const sections: Section[] = useMemo(() => [
    {
      id: 'about',
      title: 'About Me',
      component: <AboutMe />
    },
    {
      id: 'experience',
      title: 'Experience',
      component: <Experience />
    },
    {
      id: 'work',
      title: 'Work History',
      component: <WorkExperience />
    },
    {
      id: 'contact',
      title: 'Contact',
      component: <ContactInformation />
    },  ], []);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingSpinner}></div>
      </div>
    );
  }

  return (
    <div className={styles.profile} role="main">
      <div className={styles.profileGrid}>
        {sections.map(section => (
          <section
            key={section.id}
            id={section.id}
            className={styles.profileSection}
            aria-labelledby={`${section.id}-heading`}
          >
            {React.cloneElement(section.component, {
              headingId: `${section.id}-heading`
            })}
          </section>
        ))}
      </div>
    </div>
  );
});

export default Profile;